import { render, staticRenderFns } from "./CustomerAuthList.vue?vue&type=template&id=2c150919&scoped=true"
import script from "./CustomerAuthList.vue?vue&type=script&lang=js"
export * from "./CustomerAuthList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c150919",
  null
  
)

export default component.exports